import React, { FC } from 'react'

import SkuImage from '@/checkout-instore-legacy/components/Commons/SkuImage'
import { useMediaQuery } from '@/checkout-instore-legacy/hooks/mediaQuery'

interface ProductImageProps {
  src: string
  alt: string
  sizes?: {
    phone: number
    tablet: number
  }
}
const defaultSize = {
  phone: 72,
  tablet: 112,
}

const ProductImage: FC<ProductImageProps> = ({
  src,
  alt,
  sizes = defaultSize,
}) => {
  const { value: imageSize } = useMediaQuery(sizes)

  return (
    <div
      className="no-print "
      style={{
        boxSizing: 'content-box',
        minWidth: imageSize,
        minHeight: imageSize,
      }}
    >
      <SkuImage
        url={src}
        alt={alt}
        width={imageSize}
        height={imageSize}
        highDensityFactor={window.devicePixelRatio}
      />
    </div>
  )
}

export default ProductImage
